/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './index.scss'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Empty, Skeleton, message, Form } from 'antd'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import SystemUserAvatar from '../Custom/SystemUserAvatar'
import EditUserProfile from '../Custom/EditUserProfile'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isEdit: false
		}

		this.handleSubmit = this.handleSubmit.bind(this)
	}

	handleSubmit(e) {
		e.preventDefault()
		const { form, saveSystemUser, user_uid } = this.props
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			const fileList = _.has(values.avatar, 'fileList') ? values.avatar.fileList : []
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const files = []
			if (formattedFiles.length > 0) {
				files.push(formattedFiles[formattedFiles.length - 1])
			}
			delete values.avatar

			let params = Object.assign({}, values, { files, user_uid })
			console.log('params', params)

			message.loading({ key: 'set_user', content: 'Updating user details, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveSystemUser(params).then((response) => {
					this.setState({ isSaving: false, isEdit: false })
					message.success({ key: 'set_user', content: 'User details successfully updated.' })
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving system user')
					message.error({ key: 'set_user', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onCancel, user_uid, form } = this.props
		const { isEdit, isSaving } = this.state

		return (
			<React.Fragment>
				 <Modal
				 	title='View Details'
					width='40%'
					visible={visible}
					onCancel={() => {
						if (isEdit) {
							this.setState({ isEdit: false })
						} else {
							onCancel()
						}
					}}
					onOk={(e) => {
						if (!isEdit) {
							this.setState({ isEdit: true })
						} else {
							this.handleSubmit(e)
						}
					}}
					okText={isEdit ? 'Save' : 'Edit Details'}
					confirmLoading={isSaving}
					maskClosable={!isSaving}
					destroyOnClose
				>
					<React.Fragment>
						{
							!isEdit &&
							<Query query={USER_DETAILS} variables={{ user_uid }}>
								{({ loading, error, data }) => {
									if (loading) return <Skeleton active/>
									if (error) return <Empty />

									let userDetails = _.has(data,'userDetailsByUid') ? data.userDetailsByUid : {}
									console.log('userDetails', userDetails)
									return (
										<Row>
											<Row type='flex' justify='center'>
												<SystemUserAvatar size={97} user_uid={userDetails.uid} />
											</Row>
											<Row gutter={24} style={{ marginTop: 20 }}>
												<Col style={{ textAlign: 'right' }} md={10} sm={24}><h4 style={{ color: 'gray' }}>Name</h4></Col>
												<Col md={14} sm={12}><h4>{userDetails.full_name}</h4></Col>
											</Row>
											<Row gutter={24} style={{ marginTop: 10 }}>
												<Col style={{ textAlign: 'right' }} md={10} sm={24}><h4 style={{ color: 'gray' }}>Username</h4></Col>
												<Col md={14} sm={12}><h4>{userDetails.username}</h4></Col>
											</Row>
											<Row gutter={24} style={{ marginTop: 10 }}>
												<Col style={{ textAlign: 'right' }} md={10} sm={24}><h4 style={{ color: 'gray' }}>Email</h4></Col>
												<Col md={14} sm={12}><h4>{userDetails.email}</h4></Col>
											</Row>
											<Row gutter={24} style={{ marginTop: 10 }}>
												<Col style={{ textAlign: 'right' }} md={10} sm={24}><h4 style={{ color: 'gray' }}>Gender</h4></Col>
												<Col md={14} sm={12}><h4>{userDetails.gender}</h4></Col>
											</Row>
											<Row gutter={24} style={{ marginTop: 10 }}>
												<Col style={{ textAlign: 'right' }} md={10} sm={24}><h4 style={{ color: 'gray' }}>User Type</h4></Col>
												<Col md={14} sm={12}><h4>{userDetails.user_type}</h4></Col>
											</Row>
										</Row>
									)
								}}
							</Query>
						}
						{
							isEdit &&
							<EditUserProfile 
								onSubmit={this.handleSubmit}
								form={form}
								user_uid={user_uid}
								onClose={() => this.setState({ isEdit: false })}
							/>
						}
					</React.Fragment>
				</Modal>
			</React.Fragment>
		)
	}
}

const USER_DETAILS = gql`
    query userDetailsByUid($user_uid: String) {
		userDetailsByUid(user_uid: $user_uid)
    }
`

const SET_SYSTEM_USER = gql`
    mutation setSystemUser($input: JSON) {
		setSystemUser(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	Form.create({ name: 'form-edit-profile' }),
	graphql(SET_SYSTEM_USER, {
		props({ mutate }) {
			return {
				saveSystemUser(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['userDetailsByUid','SystemUserAvatar']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
